import { PENDING_TEAM_INVITE_MODAL_ID } from '@/atoms/pending-team-invite-modal-ids';
import { useJoinWorkspaceDialogPorts } from '@/composition/hosts/join-workspace-dialog-ports';
import { useQueuedModal } from '@/hooks/useQueuedModal';
import { toast } from '@heidi/design-system/toast';
import { JoinWorkspaceDialog, pendingTeamInviteModalMessages } from '@heidi/workspace';
import {
  useMutateDeclineTeamInvitation,
  useQueryPendingTeamInvitations,
} from '@heidi/workspace/data';
import { useIntl } from 'react-intl';

/**
 * Prompts a user who signed up without opening their invite link. Ignoring declines,
 * deleting the invitation so the user falls through to normal product onboarding.
 */
export function PendingTeamInviteModal() {
  const intl = useIntl();
  const { isOpen } = useQueuedModal(PENDING_TEAM_INVITE_MODAL_ID);
  const { data: invitationsData } = useQueryPendingTeamInvitations();
  const { mutate: declineInvite } = useMutateDeclineTeamInvitation();
  const joinDialogPorts = useJoinWorkspaceDialogPorts();

  const invitation = invitationsData?.pending_invitations[0];

  if (!isOpen || !invitation) {
    return null;
  }

  return (
    <JoinWorkspaceDialog
      invitation={{
        team_id: invitation.team_id,
        workspace_name: invitation.team_name,
      }}
      dismissible={false}
      onIgnore={() =>
        declineInvite(
          { teamId: invitation.team_id },
          {
            // The prompt is non-dismissible and only stands down once the
            // invitation is gone, so a silent failure would strand the user.
            onError: () =>
              toast({
                tone: 'destructive',
                title: intl.formatMessage(pendingTeamInviteModalMessages.declineFailed),
              }),
          }
        )
      }
      onClose={() => undefined}
      ports={joinDialogPorts}
    />
  );
}
